import { Grid } from "@mui/material";
import ProjectValidationTimeline from "./time-line/ProjectValidationTimeline";
import ValidationsDocuments from "./validation-documents/ValidationsDocuments";
import usePropertyHelpTypeLocations from "../../../../hooks/helps/usePropertyHelpTypeLocations";

const ValidationProjectSection = () => {
  const { isProject } = usePropertyHelpTypeLocations();

  if (!isProject) return null;
  return (
    <Grid container rowGap={2}>
      <Grid item xs={12}>
        <ProjectValidationTimeline />
      </Grid>
      <Grid item xs={12}>
        <ValidationsDocuments />
      </Grid>
    </Grid>
  );
};

export default ValidationProjectSection;
